export default __webpack_public_path__ + "static/media/backArrowDisabled.629a57c6.svg";